// extracted by mini-css-extract-plugin
export var container = "_a7-0";
export var icon = "_a7-1";
export var text = "_a7-2";